import { DetailedMetricTableResponse } from '../../api-models/types.gen';
import { OutcomeDetailedMetricsTab } from '../../types/table.type';

export default function adaptTable(table: DetailedMetricTableResponse): OutcomeDetailedMetricsTab {
  return {
    tabName: table.table_name,
    columnNames: table.column_names,
    requiresDedicatedQuery: table.requires_dedicated_query ?? false,
    dedicatedQueryRowNames: new Set(
      table.rows.filter((row) => row.requires_dedicated_query).map((r) => r.row_name),
    ),
    rows: table.rows.map((row) => ({
      ...(row.row_id != null && { id: row.row_id }),
      cells: [
        { value: row.row_name },
        ...row.metrics.map((metric) => ({ value: metric.value_string, trend: metric.trend })),
      ],
    })),
  };
}
